import styled from '@emotion/styled';
import { breakpoints } from 'gatsby-theme-apollo';

const Hero = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 600;
  margin: 15px 0px;
  width: 100%;
  overflow: hidden;
`;

const HeroImg = styled.img(props => ({
  width: '100%',
  maxWidth: '499px',
  height: 'auto',
  [breakpoints.sm]: {
    display: 'inline'
  }
}));

export { Hero, HeroImg };
